export default __webpack_public_path__ + "static/media/card1.a897d173.png";